import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, message, Select, Input, Modal } from "antd";
import { PlusOutlined, DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { FormItem, InputItem, SelectItem, TextAreaItem, DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import { cmmsPost, TIPOS_SERVICIO } from "../cmmsComun";

const { Option } = Select;

let contador = 0;
const llave = () => `k${Date.now()}_${contador++}`;

const actividadVacia = () => ({ key: llave(), titulo: "", descripcion: "" });

const seccionVacia = () => ({ key: llave(), titulo: "Rutina de mantenimiento", tipo: "checklist", actividades: [actividadVacia()] });

const mover = (lista, i, delta) => {
    const j = i + delta;
    if (j < 0 || j >= lista.length) return lista;
    const copia = [...lista];
    [copia[i], copia[j]] = [copia[j], copia[i]];
    return copia;
};

// Editor de rutina: titulo + secciones con su lista de pasos.
// Las secciones se manejan en estado (no en Form.List) para poder moverlas y duplicarlas.
class ModalRutina extends Component {
    formRef = React.createRef();
    state = { loading: false, secciones: [seccionVacia()], pegar: null };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.formRef.current?.resetFields();
            this.setState({ secciones: [seccionVacia()], pegar: null });
            if (this.props.modo === "editar" && this.props.rutinaId) this.consultar();
        }
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "datosRutinaCMMS", { id: this.props.rutinaId });
            if (res.data.success !== 2) return message.error(res.data.message || "No se encontró la rutina");
            const r = res.data.rutina;
            this.formRef.current?.setFieldsValue({ titulo: r.titulo, tipoServicio: r.tipoServicio, descripcion: r.descripcion });
            this.setState({
                secciones: (r.secciones || []).map((s) => ({ ...s, key: llave(), actividades: (s.actividades || []).map((a) => ({ ...a, key: llave() })) })),
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    // ─── Edicion del estado ─────────────────────────────────────────────────
    setSeccion = (i, cambios) => this.setState((s) => ({ secciones: s.secciones.map((x, j) => (j === i ? { ...x, ...cambios } : x)) }));

    setActividad = (i, k, cambios) =>
        this.setState((s) => ({
            secciones: s.secciones.map((x, j) => (j === i ? { ...x, actividades: x.actividades.map((a, n) => (n === k ? { ...a, ...cambios } : a)) } : x)),
        }));

    agregarActividad = (i) => this.setSeccion(i, { actividades: [...this.state.secciones[i].actividades, actividadVacia()] });

    quitarActividad = (i, k) => this.setSeccion(i, { actividades: this.state.secciones[i].actividades.filter((_, n) => n !== k) });

    moverActividad = (i, k, d) => this.setSeccion(i, { actividades: mover(this.state.secciones[i].actividades, k, d) });

    // Pegar varias actividades a la vez, una por renglon.
    aplicarPegado = () => {
        const { indice, texto } = this.state.pegar || {};
        const lineas = String(texto || "")
            .split(/\r?\n/)
            .map((l) => l.replace(/^\s*[\d]+[.)-]\s*/, "").trim())
            .filter(Boolean);
        if (!lineas.length) return this.setState({ pegar: null });
        const seccion = this.state.secciones[indice];
        const nuevas = lineas.map((l) => ({ ...actividadVacia(), titulo: l }));
        const existentes = seccion.actividades.filter((a) => String(a.titulo || "").trim());
        this.setSeccion(indice, { actividades: [...existentes, ...nuevas] });
        this.setState({ pegar: null });
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const secciones = this.state.secciones.map(({ key, ...s }) => ({ ...s, tipo: "checklist", actividades: s.actividades.map(({ key: _k, ...a }) => a) }));
            const ruta = this.props.modo === "editar" ? "editarRutinaCMMS" : "agregarRutinaCMMS";
            const res = await cmmsPost(this.props, ruta, { ...values, id: this.props.rutinaId, secciones });
            if (res.data.success === 2) {
                message.success(this.props.modo === "editar" ? "Rutina actualizada" : `Rutina registrada (${res.data.folio})`);
                this.props.onClose(res.data.codigo);
            } else {
                message.error(res.data.message || "No se pudo guardar la rutina");
            }
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar la rutina");
        } finally {
            this.setState({ loading: false });
        }
    };

    renderActividadChecklist(i, k, a, total) {
        return (
            <div key={a.key} style={{ display: "flex", gap: 6, alignItems: "flex-start", marginBottom: 6 }}>
                <span style={{ width: 30, paddingTop: 5, color: "#7a8794", fontSize: 12 }}>{`${i + 1}.${k + 1}`}</span>
                <Input placeholder="Actividad (ej. Probar frenos)" value={a.titulo} onChange={(e) => this.setActividad(i, k, { titulo: e.target.value })} style={{ flex: 2 }} />
                <Input placeholder="Detalle (opcional)" value={a.descripcion} onChange={(e) => this.setActividad(i, k, { descripcion: e.target.value })} style={{ flex: 3 }} />
                {this.botonesActividad(i, k, total)}
            </div>
        );
    }

    botonesActividad(i, k, total) {
        return (
            <div style={{ display: "flex", gap: 2 }}>
                <ButtonItem type="default" size="small" htmlType="button" icon={<ArrowUpOutlined />} disabled={k === 0} onClick={() => this.moverActividad(i, k, -1)} />
                <ButtonItem type="default" size="small" htmlType="button" icon={<ArrowDownOutlined />} disabled={k === total - 1} onClick={() => this.moverActividad(i, k, 1)} />
                <ButtonItem type="default" size="small" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.quitarActividad(i, k)} />
            </div>
        );
    }

    renderSeccion(s, i) {
        return (
            <DynamicCardForm
                key={s.key}
                xs={24}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <UnorderedListOutlined />
                        {`${i + 1}. ${s.titulo || "Sección"}`}
                    </span>
                }
                headerRight={
                    <span style={{ display: "flex", gap: 4 }}>
                        <ButtonItem type="default" size="small" htmlType="button" icon={<ArrowUpOutlined />} disabled={i === 0} onClick={() => this.setState((st) => ({ secciones: mover(st.secciones, i, -1) }))} />
                        <ButtonItem type="default" size="small" htmlType="button" icon={<ArrowDownOutlined />} disabled={i === this.state.secciones.length - 1} onClick={() => this.setState((st) => ({ secciones: mover(st.secciones, i, 1) }))} />
                        <ButtonItem type="default" size="small" htmlType="button" rojo icon={<DeleteOutlined />} disabled={this.state.secciones.length === 1} onClick={() => this.setState((st) => ({ secciones: st.secciones.filter((_, j) => j !== i) }))} />
                    </span>
                }
            >
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
                    <Input value={s.titulo} placeholder="Título de la sección" onChange={(e) => this.setSeccion(i, { titulo: e.target.value })} style={{ flex: 1, minWidth: 220 }} />
                </div>
                {s.actividades.map((a, k) => this.renderActividadChecklist(i, k, a, s.actividades.length))}
                <div style={{ display: "flex", gap: 8 }}>
                    <ButtonItem type="dashed" htmlType="button" icon={<PlusOutlined />} onClick={() => this.agregarActividad(i)}>
                        Agregar actividad
                    </ButtonItem>
                    <ButtonItem type="link" htmlType="button" onClick={() => this.setState({ pegar: { indice: i, texto: "" } })}>
                        Pegar varias (una por renglón)
                    </ButtonItem>
                </div>
            </DynamicCardForm>
        );
    }

    render() {
        const editar = this.props.modo === "editar";
        return (
            <>
                <ModalFormCMMS
                    titulo={editar ? "Editar rutina" : "Nueva rutina"}
                    subtitulo="Pasos a seguir en el servicio. Al usarla en un servicio se copia: los cambios posteriores no alteran servicios ya hechos."
                    icono={<UnorderedListOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />}
                    visible={this.props.visible}
                    loading={this.state.loading}
                    onCancel={() => this.props.onClose()}
                    formRef={this.formRef}
                    name="rutinaCMMS"
                    onFinish={this.onFinish}
                    textoGuardar={editar ? "Guardar cambios" : "Registrar rutina"}
                    width={1080}
                >
                    <DynamicCardForm title="Datos" xs={24}>
                        <Row gutter={12}>
                            <Col xs={24} md={14}>
                                <FormItem label="Título" name="titulo" required max={200}>
                                    <InputItem placeholder="Ej. Rutina de mantenimiento preventivo para cama hospitalaria eléctrica" />
                                </FormItem>
                            </Col>
                            <Col xs={24} md={10}>
                                <FormItem label="Tipo de servicio" name="tipoServicio" initialValue={1} tooltip="Tipo de servicio para el que se usa esta rutina.">
                                    <SelectItem placeholder="Tipo de servicio">
                                        {TIPOS_SERVICIO.map((t) => (
                                            <Option key={t.value} value={t.value}>
                                                {t.label}
                                            </Option>
                                        ))}
                                    </SelectItem>
                                </FormItem>
                            </Col>
                            <Col xs={24}>
                                <FormItem label="Descripción" name="descripcion">
                                    <TextAreaItem rows={1} placeholder="Opcional" />
                                </FormItem>
                            </Col>
                        </Row>
                    </DynamicCardForm>
                    {this.state.secciones.map((s, i) => this.renderSeccion(s, i))}
                    <Col xs={24} style={{ marginBottom: 12, display: "flex", gap: 8 }}>
                        <ButtonItem type="dashed" htmlType="button" icon={<UnorderedListOutlined />} onClick={() => this.setState((s) => ({ secciones: [...s.secciones, seccionVacia()] }))}>
                            Agregar sección
                        </ButtonItem>
                    </Col>
                </ModalFormCMMS>
                <Modal
                    visible={!!this.state.pegar}
                    title="Pegar varias actividades"
                    onCancel={() => this.setState({ pegar: null })}
                    onOk={this.aplicarPegado}
                    okText="Agregar"
                    cancelText="Cancelar"
                >
                    <div style={{ fontSize: 12, color: "#7a8794", marginBottom: 6 }}>Una actividad por renglón. Se quitan los números del inicio (“1.”, “2)”).</div>
                    <Input.TextArea
                        rows={10}
                        value={this.state.pegar?.texto}
                        onChange={(e) => this.setState({ pegar: { ...this.state.pegar, texto: e.target.value } })}
                        placeholder={"Inspección visual\nRevisión eléctrica\nProbar frenos"}
                    />
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalRutina);
